import { MutableRefObject } from 'react';

export function getDraggableRowByID(id: string, tableRef: MutableRefObject<HTMLDivElement | null>) {
  return tableRef?.current?.querySelector(`#row_${id}`) as HTMLElement;
}
